import { Action } from './action';
import { BaseEntity } from './base-entity';

export class UserRightValue extends BaseEntity{
    Action: Action;
    Value: boolean;
    UserID: number;
    CompanyID: number;
    OrgJedID: number;

    Deserialize(input: any){
        this.Action = new Action().Deserialize(input.Action);
        this.Value = input.Value;
        this.UserID = input.UserID;
        this.CompanyID = input.CompanyID;
        this.OrgJedID = input.OrgJedID;

        return this;
    }
}